import clsx from 'clsx'

import { useBooleanState } from '@/shared/lib/hooks/useBooleanState'

import { CloseIcon } from '../../assets/close-icon'
import { OpenIcon } from '../../assets/open-icon'

import cl from './style.module.scss'

export const SummaryToday = () => {
	const { active, disable, enable } = useBooleanState()
	return (
		<li className={clsx(cl.item, { [cl.item_active]: active })}>
			<p className={clsx(cl.label, { [cl.label_mb]: active })}>Сегодня.</p>
			<h4 className={clsx(cl.title, { [cl.title_hidden]: active })}>
				Независимая сервисная сеть с&nbsp;собственной системой обучения и&nbsp;оборудованием.
			</h4>
			<p className={clsx(cl.subtitle, { [cl.subtitle_hidden]: !active })}>
				С&nbsp;2022&nbsp;г. новые модели Apple официально не&nbsp;обслуживаются в&nbsp;России.
			</p>
			<p className={clsx(cl.subtitle, { [cl.subtitle_hidden]: !active })}>
				Мы&nbsp;адаптировались: построили новую систему обучения, закупили оборудование и&nbsp;освоили ремонт устройств
				без поддержки Apple.
			</p>
			<p className={clsx(cl.subtitle, { [cl.subtitle_hidden]: !active })}>
				Качество работ остаётся нашим главным приоритетом&nbsp;&mdash; мы&nbsp;придерживаемся тех&nbsp;же высоких
				стандартов, что и&nbsp;раньше.
			</p>
			<p className={clsx(cl.subtitle, { [cl.subtitle_hidden]: !active })}>
				Более того, теперь у&nbsp;клиентов появилось больше возможностей для решения любых вопросов по&nbsp;ремонту, так
				как мы&nbsp;можем предлагать альтернативные ремонтные решения.
			</p>
			<button className={clsx(cl.button, { [cl.button_hidden]: active })} onClick={enable}>
				<OpenIcon />
			</button>

			<button className={clsx(cl.button, { [cl.button_hidden]: !active })} onClick={disable}>
				<CloseIcon />
			</button>
		</li>
	)
}
